"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchBoxLeft = void 0;
var React = require("react");
var recompose_1 = require("recompose");
var Icon_1 = require("components/Icon");
var SearchTypeButton_1 = require("../SearchTypeButton");
require("./styles.scss");
var onSearchIconClick = function (props) { return function () {
    props.onSearchFiles(props.searchOptions);
}; };
var enhance = (0, recompose_1.compose)((0, recompose_1.lifecycle)({
    shouldComponentUpdate: function (nextProps) {
        if (this.props.searchOptions.moreSearch !==
            nextProps.searchOptions.moreSearch ||
            this.props.searchOptions.searchFileType !==
                nextProps.searchOptions.searchFileType ||
            this.props.searchDropdownToggled !== nextProps.searchDropdownToggled) {
            return true;
        }
        return false;
    }
}), recompose_1.pure);
exports.SearchBoxLeft = enhance(function (props) {
    return (React.createElement("span", { className: "file-list-search-box-left" },
        React.createElement(Icon_1.Icon, { onClick: onSearchIconClick(props), className: "fa-search" }),
        props.searchOptions.moreSearch && (React.createElement(SearchTypeButton_1.SearchTag, { type: 'ADVANCED_SEARCH', onClose: function () {
                props.onClearAll();
                props.toggleMoreSearch(false);
            } })),
        props.searchOptions.searchFileType &&
            props.searchOptions.searchFileType.isSome() && (React.createElement(SearchTypeButton_1.SearchTypeButton, { searchOptions: props.searchOptions, clearSearchFileTypeClicked: props.clearSearchFileTypeClicked }))));
});
